module.exports = __webpack_public_path__ + "img/title-bg.24c5cadd.png";